import { render, staticRenderFns } from "./ShowCampaign.vue?vue&type=template&id=da38b2fc&"
import script from "./ShowCampaign.vue?vue&type=script&lang=js&"
export * from "./ShowCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports